import { render, staticRenderFns } from "./CartBottomCard.vue?vue&type=template&id=62498731&scoped=true"
import script from "./CartBottomCard.vue?vue&type=script&lang=ts"
export * from "./CartBottomCard.vue?vue&type=script&lang=ts"
import style0 from "./CartBottomCard.vue?vue&type=style&index=0&id=62498731&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62498731",
  null
  
)

export default component.exports